import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ErrorModalVisuals, resolveErrorModalVisuals } from '../../../core/utils/api-error.util';

@Component({
  selector: 'app-error-info-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './error-info-modal.component.html',
  styleUrls: ['./error-info-modal.component.scss'],
})
export class ErrorInfoModalComponent {
  @Input() open = false;
  @Input() message = '';
  @Input() title = 'Oups, une erreur';
  @Input() showRetry = false;

  @Output() closed = new EventEmitter<void>();
  @Output() retried = new EventEmitter<void>();

  get visuals(): ErrorModalVisuals {
    return resolveErrorModalVisuals(this.message);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) {
      this.close();
    }
  }

  close(): void {
    this.closed.emit();
  }

  retry(): void {
    this.retried.emit();
  }
}
